// Service for saving and retrieving form configurations from the backend.

export const textJson = (formFields) => {
  return formFields.reduce((acc, field) => {
    acc[field.key] = {
      key: field.key,
      type: field.type,
      hebrew_name: field.hebrewLabel,
      require: field.required,
      order: field.order,
    };
    if (field.dependsOn && field.condition) {
      acc[field.key].dependencies = [{field: field.dependsOn, condition: field.condition}]
    }
    if (field.type === "select")
      acc[field.key].option = field.option;
    if (field.type === "textarea")
      acc[field.key].range = field.range.map(Number);
    return acc;
  }, {});
};

export const fileJson = (formFields) => {
  return formFields.reduce((acc, field) => {
    acc[field.key] = {
      hebrew_name: field.hebrewLabel,
      require: field.required,
      order: field.order,
      max: field.max,
      private: field.private,
      comment: field.comment || null,
    };
    return acc;
  }, {});
};
